import React, { useState } from 'react';
import { Link, Outlet } from 'react-router-dom';
import './layout.css';
import logo from '../assets/FVOL2.png'; 
import Footer from './pages/footer';
import ScrollToTop from './pages/scroll';
import { FaTwitter, FaInstagram, FaFacebook, FaLinkedin, FaTiktok, FaBars, FaTimes } from 'react-icons/fa';

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const closeMenu = () => {
        setIsMenuOpen(false);
    };

    return (
        <div className="layout">
            <header className="header">
                <div className="header-container">
                    {/* Logo - Left Side */}
                    <div className="logo">
                        <Link to="/" className="logo-link" onClick={closeMenu}>
                            <img src={logo} alt="Media" className="logo-image" />
                        </Link>
                    </div>

                    {/* Desktop Navigation - Hidden on Mobile */}
                    <nav className="navigationss desktop-nav">
                        <ul className="nav-listss">
                            <li className="nav-itemss">
                                <Link to="/" className="nav-linkss">Home</Link>
                            </li>
                            <li className="nav-itemss">
                                <Link to="/about" className="nav-linkss">About Us</Link>
                            </li>
                            <li className="nav-itemss">
                                <Link to="/services" className="nav-linkss">Services</Link>
                            </li>
                            <li className="nav-itemss">
                                <Link to="/portfolio" className="nav-linkss">Portfolio</Link>
                            </li>
                            <li className="nav-itemss">
                                <Link to="/reviews" className="nav-linkss">Client Reviews</Link>
                            </li>
                            <li className="nav-itemss">
                                <Link to="/packages" className="nav-linkss">Our Packages</Link>
                            </li>
                        </ul>
                    </nav>

                    {/* Right Side - Hamburger Menu + Social Links (reordered) */}
                    <div className="header-right">
                        {/* Hamburger Menu Button - Now before social icons */}
                        <button className="hamburger-btn" onClick={toggleMenu}>
                            <FaBars />
                        </button>

                        {/* Social Media Links */}
                        <div className="social-lins">
                            <a href="https://x.com/404fxVisualss" className="social-lin" target="_blank" rel="noopener noreferrer">
                                <FaTwitter />
                            </a>
                            <a href="https://www.instagram.com/404fxvisuals?igsh=OG9reDNldTU0cDlh" className="social-lin" target="_blank" rel="noopener noreferrer">
                                <FaInstagram />
                            </a>
                            <a href="https://www.facebook.com/profile.php?id=61584148853364" className="social-lin" target="_blank" rel="noopener noreferrer">
                                <FaFacebook />
                            </a>
                            <a href="https://www.linkedin.com/company/404fxvisuals/about/?viewAsMember=true" className="social-lin" target="_blank" rel="noopener noreferrer">
                                <FaLinkedin />
                            </a>
                            <a href="https://www.tiktok.com/@404fxvisuals" className="social-lin" target="_blank" rel="noopener noreferrer">
                                <FaTiktok />
                            </a>
                        </div>
                    </div>
                </div>

                {/* Mobile Navigation Menu - Slides in from right */}
                <div className={`mobile-nav-menu ${isMenuOpen ? 'active' : ''}`}>
                    <div className="mobile-nav-header">
                        <h3>Menu</h3>
                        <button className="close-btn" onClick={closeMenu}>
                            <FaTimes />
                        </button>
                    </div>
                    <ul className="mobile-nav-list">
                        <li className="mobile-nav-item">
                            <Link to="/" className="mobile-nav-link" onClick={closeMenu}>Home</Link>
                        </li>
                        <li className="mobile-nav-item">
                            <Link to="/about" className="mobile-nav-link" onClick={closeMenu}>About Us</Link>
                        </li>
                        <li className="mobile-nav-item">
                            <Link to="/services" className="mobile-nav-link" onClick={closeMenu}>Services</Link>
                        </li>
                        <li className="mobile-nav-item">
                            <Link to="/portfolio" className="mobile-nav-link" onClick={closeMenu}>Portfolio</Link>
                        </li>
                        <li className="mobile-nav-item">
                            <Link to="/reviews" className="mobile-nav-link" onClick={closeMenu}>Client Reviews</Link>
                        </li>
                        <li className="mobile-nav-item">
                            <Link to="/packages" className="mobile-nav-link" onClick={closeMenu}>Our Packages</Link>
                        </li>
                    </ul>
                </div>

                {/* Overlay when menu is open */}
                {isMenuOpen && <div className="menu-overlay" onClick={closeMenu}></div>}
            </header>

            <main className="main-content">
                <Outlet />
                <Footer />
                <ScrollToTop />
            </main>
        </div>
    );
};

export default Header;